/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
export default class ActionCreator<T, P, M = undefined> {
  public readonly type: T;

  public readonly payload!: P;

  public readonly meta!: M;

  public constructor(type: T) {
    this.type = type;
  }

  public create = (payload?: P, meta?: M) => ({ type: this.type, payload, meta });
}
